import React from 'react';
import { RotateCw } from 'lucide-react';
import Header from '../Common/Header';
import Footer from '../Common/Footer';
import ErrorPage from '../../Common/ErrorPages';

const CLSDKServerError = ({ onRetry }) => (
  <ErrorPage
    Header={Header}
    Footer={Footer}
    brandAttr="CLS"
    code="500"
    title="Noget gik galt"
    description="Der opstod en uventet fejl. Prøv igen, eller gå tilbage til forsiden."
    primaryCta={{
      label: 'Prøv igen',
      onClick: onRetry || (() => window.location.reload()),
      icon: <RotateCw size={20} />,
    }}
    secondaryCta={{ label: 'Til forsiden', to: '/clothing/cls-dk' }}
  />
);

export default CLSDKServerError;
